export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8418.03095460.jpg";